//** Required */
export const PATH = {
  login: "/login",
  user_profile: "/user-profile",
  dashboard: {
    dashboard: "/dashboard",
    network_view: "/dashboard/network-view",
  },
  monitor: {},
  congigure: {},
  reports: {
    change_log: "/reports/change-log",
    summary_report: "/reports/summary-report",
    alerts: "/reports/alerts",
    licenses: "/reports/licenses",
  },
  settings: {
    account: "/settings/account",
    organization: "/settings/organization",
    organization_id: "/settings/organization/:id",
    license_management: "/settings/license-management",
    license_history: "/settings/license-history",
    saml_configuration: "/settings/advanced-settings/saml-configuration",
    sms_configuration: "/settings/advanced-settings/sms-configuration",
    syslog_server_configuration: "/settings/advanced-settings/syslog-server-configuration",
  },
  help: {
    announcements: "/help/announcements",
  },
  terms: "/terms",
  privacy: "/privacy",
};

//** Other */
export const OPEN_ALL = {
  enableOrgDp: true,
  enableSiteDp: true,
};

export const OPEN_ORG = {
  enableOrgDp: true,
  enableSiteDp: false,
};

export const OPEN_SITE = {
  enableOrgDp: false,
  enableSiteDp: true,
};

export const FORBID_ALL = {
  enableOrgDp: false,
  enableSiteDp: false,
};